/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import ShimmedObjecthasOwn from 'object.hasown';
import { ReferenceType, MemberType } from './globalTypes';
import { ThreadSafetyTag, ApiTag, SecurityTag } from '@modules/ui/tags/types';
import { TCompileTree } from '@modules/markdownProcessor/markdownProcessor';
import { Locale } from '@rbx/intl';

// TODO: replace use of null with undefined (avoid multiple definitions of
// empty) to be able to simplify types, from parseEngineApi
export interface Security {
  read: SecurityTag | null;
  write: SecurityTag | null;
}

export type CodeSample = {
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
};

export type ReferenceMemberReturn = {
  type: string;
  summary: string;
};

export type ReferenceMemberParameter = {
  type: string;
  name: string;
  default: string | null;
  summary: string | TCompileTree | null;
};

export const isReferenceMemberParameter = (
  candidate: unknown,
): candidate is ReferenceMemberParameter =>
  !!candidate && typeof candidate === 'object' && 'type' in candidate && 'name' in candidate;

export type ReadWriteSecurityTagsObj = {
  read: SecurityTag | null;
  write: SecurityTag | null;
};
export interface APIReferenceProperty {
  type: string;
  name: string;
  summary: string | TCompileTree | null;
  description: string | TCompileTree | null;
  default: string | null;
  codeSamples: CodeSample[] | null;
  security: ReadWriteSecurityTagsObj | null;
  tags: ApiTag[] | null;
  threadSafety: ThreadSafetyTag | null;
  deprecationMessage?: string | null;
  capabilities: ApiTag[] | null;
  writeCapabilities: ApiTag[] | null;
}

// TODO clean up these types
export type APIReferenceMethod = ApiReferenceMemberCollectionParams & {
  name: string;
  summary: string | TCompileTree | null;
  description: string | TCompileTree | null;
  codeSamples: CodeSample[] | null;
  parameters: ReferenceMemberParameter[] | null;
  returns: ReferenceMemberReturn[] | null;
  security: SecurityTag[] | null;
  tags: ApiTag[] | null;
  threadSafety: ThreadSafetyTag | null;
  capabilities: ApiTag[] | null;
  writeCapabilities: ApiTag[] | null;
};

export type APIReferenceCallback = APIReferenceMethod & {
  security: SecurityTag[] | null;
  deprecationMessage: string | null;
};

export interface APIReferenceFunction extends ApiReferenceMemberCollectionParams {
  name: string;
  summary: string | TCompileTree | null;
  description: string | TCompileTree | null;
  codeSamples: CodeSample[] | null;
  parameters: ReferenceMemberParameter[] | null;
  returns: ReferenceMemberReturn[] | null;
  tags: ApiTag[] | null;
}

export interface APIReferenceMathOperation extends ApiReferenceMemberCollectionParams {
  name: string;
  operation: string;
  summary: string | TCompileTree | null;
  description: string | TCompileTree | null;
  codeSamples: CodeSample[] | null;
  typeA: string;
  typeB: string;
  returnType: string;
  tags: ApiTag[] | null;
}

export interface APIReferenceConstructor extends ApiReferenceMemberCollectionParams {
  __typename: 'Constructor';
  name: string;
  summary: string | TCompileTree | null;
  description: string | TCompileTree | null;
  codeSamples: CodeSample[] | null;
  parameters: ReferenceMemberParameter[] | null;
  tags: ApiTag[] | null;
}

export type APIReferenceMemberWithParameters =
  | APIReferenceConstructor
  | APIReferenceFunction
  | APIReferenceEvent;
export type APIReferenceMemberWithReturns = APIReferenceFunction | APIReferenceMethod;
// TODO: inspect if APIReferenceEvent has returns or its equivalent = ?
export type APIReferenceMemberWithType = APIReferenceProperty;
export type APIReferenceMemberWithThreadSafetyTag =
  | APIReferenceProperty
  | APIReferenceMethod
  | APIReferenceEvent
  | APIReferenceCallback;
export type APIReferenceMemberWithSecurityTagList =
  | APIReferenceCallback
  | APIReferenceEvent
  | APIReferenceMethod;
export type APIReferenceMemberWithReadWriteSecurityObj = APIReferenceProperty;
export type APIReferenceMemberWithSecurity =
  | APIReferenceMemberWithSecurityTagList
  | APIReferenceProperty;
// has `security` property with `read` and `write` properties
export const memberHasParameters = (member: Object): member is APIReferenceMemberWithParameters =>
  ShimmedObjecthasOwn(member, 'parameters');
export const memberHasReturnValues = (member: Object): member is APIReferenceMemberWithReturns =>
  ShimmedObjecthasOwn(member, 'returns');
export const memberHasType = (member: Object): member is APIReferenceMemberWithType =>
  ShimmedObjecthasOwn(member, 'type');
export const memberHasThreadSafetyTag = (
  member: Object,
): member is APIReferenceMemberWithThreadSafetyTag => ShimmedObjecthasOwn(member, 'threadSafety');
export const memberHasSecurity = (member: Object): member is APIReferenceMemberWithSecurity =>
  ShimmedObjecthasOwn(member, 'security');
export const memberHasSecurityTagList = (
  member: Object,
): member is NonNullable<APIReferenceMemberWithSecurityTagList> =>
  memberHasSecurity(member) && Array.isArray(member.security);
export const memberHasReadWriteSecurityTagObj = (
  member: Object,
): member is APIReferenceMemberWithReadWriteSecurityObj =>
  memberHasSecurity(member) &&
  !!member.security &&
  'read' in member.security &&
  'write' in member.security;

export const isMathOperationMember = (
  member: APIReferenceMember,
): member is APIReferenceMathOperation => ShimmedObjecthasOwn(member, 'operation');

export interface APIReferenceEvent {
  name: string;
  summary: string | TCompileTree | null;
  description: string | TCompileTree | null;
  codeSamples: CodeSample[] | null;
  parameters: ReferenceMemberParameter[] | null;
  tags: ApiTag[] | null;
  security: SecurityTag[] | null;
  deprecationMessage: string | null;
  threadSafety: ThreadSafetyTag | null;
  capabilities: ApiTag[] | null;
  writeCapabilities: ApiTag[] | null;
}

export type APIReferenceMember =
  | APIReferenceConstructor
  | APIReferenceProperty
  | APIReferenceMethod
  | APIReferenceFunction
  | APIReferenceMathOperation
  | APIReferenceEvent
  | APIReferenceCallback;

export const MemberTypeListNameTranslKey = {
  // values should match translation keys in
  // 'CreatorDocumentation.APIReference' translation resources
  // to label translated API Member Type (Constructor, Property, etc.) collections
  [MemberType.Constructor]: 'Label.Constructors',
  [MemberType.Property]: 'Label.Properties',
  [MemberType.Method]: 'Label.Methods',
  [MemberType.Function]: 'Label.Functions',
  [MemberType.MathOperation]: 'Label.MathOperations',
  [MemberType.Event]: 'Label.Events',
  [MemberType.Callback]: 'Label.Callbacks',
};

// ====================================================
// GraphQL query operation: APIReference
// ====================================================
// TODO: remove GraphQL-generated types in favor of simplified types above

export interface APIReference_apiReference_ClassReference_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_ClassReference_property_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_ClassReference_property_security {
  __typename: 'Security';
  read: SecurityTag | null;
  write: SecurityTag | null;
}

export interface APIReference_apiReference_ClassReference_property {
  __typename: 'ClassProperty';
  name: string;
  summary: string | TCompileTree;
  description: string | TCompileTree;
  codeSamples: APIReference_apiReference_ClassReference_property_codeSample[] | null;
  type: string;
  tags: ApiTag[] | null;
  security: APIReference_apiReference_ClassReference_property_security | null;
  deprecationMessage: string | null;
  threadSafety: ThreadSafetyTag | null;
}

export interface APIReference_apiReference_ClassReference_method_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_ClassReference_method_parameter {
  __typename: 'Parameter';
  type: string;
  name: string;
  default: string | null;
  summary: string;
}

export interface APIReference_apiReference_ClassReference_method_return {
  __typename: 'Return';
  type: string;
  summary: string;
}

export interface APIReference_apiReference_ClassReference_method {
  __typename: 'Method';
  name: string;
  summary: string;
  description: string | null;
  codeSamples: APIReference_apiReference_ClassReference_method_codeSample[] | null;
  parameters: APIReference_apiReference_ClassReference_method_parameter[] | null;
  returns: APIReference_apiReference_ClassReference_method_return[] | null;
  tags: ApiTag[] | null;
  security: SecurityTag[] | null;
  deprecationMessage: string | null;
  threadSafety: ThreadSafetyTag | null;
}

export interface APIReference_apiReference_ClassReference_event_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_ClassReference_event_parameter {
  __typename: 'Parameter';
  type: string;
  name: string;
  default: string | null;
  summary: string;
}

export interface APIReference_apiReference_ClassReference_event {
  __typename: 'Event';
  name: string;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_ClassReference_event_codeSample[] | null;
  parameters: APIReference_apiReference_ClassReference_event_parameter[] | null;
  tags: ApiTag[] | null;
  security: SecurityTag[] | null;
  deprecationMessage: string | null;
  threadSafety: ThreadSafetyTag | null;
}

export interface APIReference_apiReference_ClassReference_callback_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_ClassReference_callback_parameter {
  __typename: 'Parameter';
  type: string;
  name: string;
  default: string | null;
  summary: string;
}

export interface APIReference_apiReference_ClassReference_callback_return {
  __typename: 'Return';
  type: string;
  summary: string;
}

export interface APIReference_apiReference_ClassReference_callback {
  __typename: 'Callback';
  name: string;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_ClassReference_callback_codeSample[] | null;
  parameters: APIReference_apiReference_ClassReference_callback_parameter[] | null;
  returns: APIReference_apiReference_ClassReference_callback_return[] | null;
  tags: ApiTag[] | null;
  security: SecurityTag[] | null;
  deprecationMessage: string | null;
  threadSafety: ThreadSafetyTag | null;
}

// note: types generated from former GraphQL query operation
// are missing some parameters per member collection ('methods', 'constructors' etc)
// ==> (short-term fix) handle all possible missing fields via this type
interface ApiReferenceMemberCollectionParams {
  tags?: ApiTag[] | null;
  security?: SecurityTag[] | null;
  deprecationMessage?: string | null;
  threadSafety?: ThreadSafetyTag | null;
}

export interface APIClassReference {
  __typename: 'ClassReference';
  id: string;
  locale: Locale;
  slug: string;
  name: string;
  type: ReferenceType;
  summary: string | TCompileTree | null;
  description: string | TCompileTree | null;
  codeSamples: APIReference_apiReference_ClassReference_codeSample[] | null;
  category: string | null;
  inherits: string[] | null;
  descendants: string[] | null;
  tags: ApiTag[] | null;
  deprecationMessage: string | null;
  // note: security tags are formed uniquely on properties
  properties:
    | (Omit<ApiReferenceMemberCollectionParams, 'security'> &
        APIReference_apiReference_ClassReference_property)[]
    | null;
  methods:
    | (ApiReferenceMemberCollectionParams & APIReference_apiReference_ClassReference_method)[]
    | null;
  events:
    | (ApiReferenceMemberCollectionParams & APIReference_apiReference_ClassReference_event)[]
    | null;
  callbacks:
    | (ApiReferenceMemberCollectionParams & APIReference_apiReference_ClassReference_callback)[]
    | null;
}

export type ClassReferenceParent = APIClassReference;

export interface APIReference_apiReference_DatatypeReference_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_DatatypeReference_constructor_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_DatatypeReference_constructor_parameter {
  __typename: 'Parameter';
  name: string;
  type: string;
  default: string | null;
  summary: string;
}

export interface APIReference_apiReference_DatatypeReference_constructor {
  __typename: 'Constructor';
  name: string;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_DatatypeReference_constructor_codeSample[] | null;
  parameters: APIReference_apiReference_DatatypeReference_constructor_parameter[] | null;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_DatatypeReference_property_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_DatatypeReference_property {
  __typename: 'DatatypeProperty';
  name: string;
  type: string;
  summary: string | TCompileTree;
  description: string | TCompileTree;
  default: string | null;
  codeSamples: APIReference_apiReference_DatatypeReference_property_codeSample[] | null;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_DatatypeReference_methods_codeSamples {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_DatatypeReference_methods_parameters {
  __typename: 'Parameter';
  type: string;
  name: string;
  default: string | null;
  summary: string;
}

export interface APIReference_apiReference_DatatypeReference_methods_returns {
  __typename: 'Return';
  type: string;
  summary: string;
}

export interface APIReference_apiReference_DatatypeReference_methods {
  __typename: 'DatatypeMethod';
  name: string;
  summary: string;
  description: string | null;
  codeSamples: APIReference_apiReference_DatatypeReference_methods_codeSamples[] | null;
  parameters: APIReference_apiReference_DatatypeReference_methods_parameters[] | null;
  returns: APIReference_apiReference_DatatypeReference_methods_returns[] | null;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_DatatypeReference_functions_codeSamples {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_DatatypeReference_functions_parameters {
  __typename: 'Parameter';
  type: string;
  name: string;
  default: string | null;
  summary: string;
}

export interface APIReference_apiReference_DatatypeReference_functions_returns {
  __typename: 'Return';
  type: string;
  summary: string;
}

export interface APIReference_apiReference_DatatypeReference_function {
  __typename: 'DatatypeFunction';
  name: string;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_DatatypeReference_functions_codeSamples[] | null;
  parameters: APIReference_apiReference_DatatypeReference_functions_parameters[] | null;
  returns: APIReference_apiReference_DatatypeReference_functions_returns[] | null;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_DatatypeReference_mathOperations_codeSamples {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_DatatypeReference_mathOperations {
  __typename: 'MathOperation';
  operation: string;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_DatatypeReference_mathOperations_codeSamples[] | null;
  typeA: string;
  typeB: string;
  returnType: string;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_DatatypeReference {
  __typename: 'DatatypeReference';
  id: string;
  locale: Locale;
  slug: string;
  name: string;
  type: ReferenceType;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_DatatypeReference_codeSample[] | null;
  category: string | null;
  constructors:
    | (ApiReferenceMemberCollectionParams &
        APIReference_apiReference_DatatypeReference_constructor)[]
    | null;
  properties:
    | (ApiReferenceMemberCollectionParams & APIReference_apiReference_DatatypeReference_property)[]
    | null;
  methods:
    | (ApiReferenceMemberCollectionParams & APIReference_apiReference_DatatypeReference_methods)[]
    | null;
  functions:
    | (ApiReferenceMemberCollectionParams & APIReference_apiReference_DatatypeReference_function)[]
    | null;
  mathOperations:
    | (ApiReferenceMemberCollectionParams &
        APIReference_apiReference_DatatypeReference_mathOperations)[]
    | null;
}

export interface APIReference_apiReference_GlobalReference_codeSamples {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_GlobalReference_properties_codeSamples {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_GlobalReference_properties {
  __typename: 'Property';
  name: string;
  type: string;
  summary: string | TCompileTree;
  description: string | TCompileTree;
  codeSamples: APIReference_apiReference_GlobalReference_properties_codeSamples[] | null;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_GlobalReference_functions_codeSamples {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_GlobalReference_functions_parameters {
  __typename: 'Parameter';
  type: string;
  name: string;
  default: string | null;
  summary: string;
}

export interface APIReference_apiReference_GlobalReference_functions_returns {
  __typename: 'Return';
  type: string;
  summary: string;
}

export interface APIReference_apiReference_GlobalReference_functions {
  __typename: 'Function';
  name: string;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_GlobalReference_functions_codeSamples[] | null;
  parameters: APIReference_apiReference_GlobalReference_functions_parameters[] | null;
  returns: APIReference_apiReference_GlobalReference_functions_returns[] | null;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_GlobalReference {
  __typename: 'GlobalReference';
  id: string;
  locale: Locale;
  slug: string;
  name: string;
  type: ReferenceType;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_GlobalReference_codeSamples[] | null;
  properties: APIReference_apiReference_GlobalReference_properties[] | null;
  functions: APIReference_apiReference_GlobalReference_functions[] | null;
}

export interface APIReference_apiReference_LibraryReference_codeSamples {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_LibraryReference_properties_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_LibraryReference_property {
  __typename: 'Property';
  name: string;
  type: string;
  summary: string | TCompileTree;
  description: string | TCompileTree;
  codeSamples: APIReference_apiReference_LibraryReference_properties_codeSample[] | null;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_LibraryReference_functions_codeSample {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_LibraryReference_functions_parameter {
  __typename: 'Parameter';
  type: string;
  name: string;
  default: string | null;
  summary: string;
}

export interface APIReference_apiReference_LibraryReference_functions_return {
  __typename: 'Return';
  type: string;
  summary: string;
}

export interface APIReference_apiReference_LibraryReference_function {
  __typename: 'Function';
  name: string;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_LibraryReference_functions_codeSample[] | null;
  parameters: APIReference_apiReference_LibraryReference_functions_parameter[] | null;
  returns: APIReference_apiReference_LibraryReference_functions_return[] | null;
  tags: ApiTag[] | null;
}

export interface APIReference_apiReference_LibraryReference {
  __typename: 'LibraryReference';
  id: string;
  locale: Locale;
  slug: string;
  name: string;
  type: ReferenceType;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_LibraryReference_codeSamples[] | null;
  properties: APIReference_apiReference_LibraryReference_property[] | null;
  functions: APIReference_apiReference_LibraryReference_function[] | null;
}

export interface APIReference_apiReference_EnumReference_codeSamples {
  __typename: 'CodeSample';
  identifier: string | null;
  displayName: string | null;
  description: string | null;
  codeSample: string | null;
  expectedOutput: string | null;
  highlightLines: string | null;
}

export interface APIReference_apiReference_EnumReference_items {
  __typename: 'EnumItem';
  deprecationMessage: string | null;
  name: string;
  summary: string;
  tags?: ApiTag[] | null;
  value: number;
}

export interface APIReference_apiReference_EnumReference {
  __typename: 'EnumReference';
  id: string;
  locale: Locale;
  slug: string;
  name: string;
  type: ReferenceType;
  summary: string;
  description: string;
  codeSamples: APIReference_apiReference_EnumReference_codeSamples[] | null;
  tags: ApiTag[] | null;
  deprecationMessage: string | null;
  items: APIReference_apiReference_EnumReference_items[];
}

export type APIReference_apiReference =
  | APIClassReference
  | APIReference_apiReference_DatatypeReference
  | APIReference_apiReference_GlobalReference
  | APIReference_apiReference_LibraryReference
  | APIReference_apiReference_EnumReference;
export type APIReference_apiReference_collection =
  | APIReference_apiReference_ClassReference_callback
  | APIReference_apiReference_ClassReference_event
  | APIReference_apiReference_ClassReference_method
  | APIReference_apiReference_ClassReference_property
  | APIReference_apiReference_DatatypeReference_codeSample
  | APIReference_apiReference_DatatypeReference_constructor
  | APIReference_apiReference_DatatypeReference_function
  | APIReference_apiReference_DatatypeReference_mathOperations
  | APIReference_apiReference_DatatypeReference_methods
  | APIReference_apiReference_DatatypeReference_property
  | APIReference_apiReference_GlobalReference_codeSamples
  | APIReference_apiReference_GlobalReference_functions
  | APIReference_apiReference_GlobalReference_properties
  | APIReference_apiReference_LibraryReference_codeSamples
  | APIReference_apiReference_LibraryReference_function
  | APIReference_apiReference_LibraryReference_property
  | APIReference_apiReference_EnumReference_codeSamples
  | APIReference_apiReference_EnumReference_items;
export interface APIReference {
  apiReference: APIReference_apiReference | null;
}

export interface APIReferenceVariables {
  id: string;
  type: ReferenceType;
  locale: Locale;
}
